module.exports = __webpack_public_path__ + "assets/white-close.d161328f0adc599d29de707dffab2304.png";